import { render, staticRenderFns } from "./LotteryDoc.vue?vue&type=template&id=5ab79777&scoped=true&"
var script = {}
import style0 from "./LotteryDoc.vue?vue&type=style&index=0&id=5ab79777&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab79777",
  null
  
)

export default component.exports